import store from "../store";
import { interpolate } from "../api/helpers/stringHelper";
const localeJson = require("../../lang/locale.json");

export function localizeMessage(message, param) {
  var locale = store.getters.selectedLocale;
  var res = interpolate(localeJson[locale]["message"][message], param);
  return res;
}

export function customValidations(Validator) {
  Validator.extend("CartValidation", {
    getMessage: field => {
      return localizeMessage("fieldFormatIsInvalid", field);
    },
    validate: (value, [args]) => {
      value = value.split("/");
      var month = value[0];
      var year = value[1] | "";
      var now = new Date();
      var currentYear = now
        .getFullYear()
        .toString()
        .substr(2, 2);
      return (
        ( month >= 1 && month <= args && month >= now.getMonth() + 1 && year == currentYear) ||
        (year > currentYear && month <= args && month >= 1)
      );
    }
  });
  Validator.extend("CardNumberValidation" , {
    getMessage: field => {
      return localizeMessage("CardNumberIsNotSupported", field);
    },
    validate:(value) => {
      value = value.charAt(0);
      return (value === "4") || (value === "5") || (value === "3");
    }
  });
}
